import { applyMiddleware, createStore, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';

import authReducer from 'reducers/auth';
import topoNodeReducer from 'reducers/toponode';
import deviceReducer from 'reducers/device';
import indeNodeReducer from 'reducers/indenode';
import aggregatorReducer from 'reducers/aggregator';
import controlReducer from 'reducers/control';
import curvesReducer from 'reducers/curve';
import modalReducer from 'reducers/modal';
import sidePanelReducer from 'reducers/sidePanel';
import pollingReducer from 'reducers/polling';
import logReducer from 'reducers/log';
import customerReducer from 'reducers/customer';

const rootReducer = combineReducers({
  auth: authReducer,
  topoNode: topoNodeReducer,
  device: deviceReducer,
  indeNode: indeNodeReducer,
  aggregator: aggregatorReducer,
  control: controlReducer,
  curve: curvesReducer,
  modal: modalReducer,
  sidePanel: sidePanelReducer,
  polling: pollingReducer,
  log: logReducer,
  customer: customerReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
